import React from "react";
import classes from "./Title.module.css";

export default function Title({ text }) {
  return <div className={classes.root}>{text}</div>;
}
